import axios from "axios";
import Cookies from "js-cookie";

const BASE_URL = process.env.REACT_APP_CHATAPI_URL;

export async function getUserSessionHistory({ userId, sessionId, page, size }) {
  const token = Cookies.get("authToken");
  if (!token) throw new Error("No auth token found");

  console.log(
    "[getUserSessionHistory] calling with:",
    `${BASE_URL}get-user-session-history`,
    "userId:", userId,
    "sessionId:", sessionId,
    "page:", page,
    "size:", size
  );

  // Use GET with query parameters (matching apiHandlers.js)
  const response = await axios.get(
    `${BASE_URL}get-user-session-history`,
    {
      params: {
        user_id: userId,
        session_id: sessionId,
        page: page,
        size: size,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  console.log("[getUserSessionHistory] response:", response.data);
  return response.data;
}